import { ontruckApi } from './instances';

const queryString = params =>
  Object.keys(params)
    .map(key => key + '=' + params[key])
    .join('&');

const getTenderQuote = async data => {
  const { data: tenderQuote } = await ontruckApi.get(`/pricing/tender_quote?${queryString(data)}`);
  return tenderQuote;
};

export { getTenderQuote };
